import { DatePipe } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatSidenav, MatSnackBar } from "@angular/material";
import { CodeTable } from "src/app/core/model/v2/code-table";
import { LanguageDetails } from "src/app/core/model/v2/languageDetails";
import { Practitioner } from "src/app/core/model/v2/practitioner/practitioner";
import { Treatment } from "src/app/core/model/v2/practitioner/treatment";
import { Specialty } from "src/app/core/model/v2/specialty";
import { CommonService } from "src/app/core/services/v2/common.service";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { UserService } from "src/app/core/services/v2/user.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { concat, fromEvent, Observable, of, Subject } from "rxjs";
import {
  map,
  debounceTime,
  distinctUntilChanged,
  tap,
  switchMap,
  catchError,
  filter,
  takeUntil,
  debounce,
} from "rxjs/operators";
import { PractitionerTreatment } from "src/app/core/model/v2/practitioner/practitionerTreatment";
import { PractitionerTreatmentsUpdate } from "src/app/core/model/v2/practitioner/practitionerTreatmentsUpdate";
import { tr } from "date-fns/locale";
import { Symptom } from "src/app/core/model/v2/practitioner/symptom";
import { PractitionerSymptom } from "src/app/core/model/v2/practitioner/practitioner-symptom";
import { PractitionerSymptomsUpdate } from "src/app/core/model/v2/practitioner/practitioner-symptoms-update";
import {
  HospitalAffiliation,
  HospitalAffiliationList,
} from "src/app/core/model/v2/hospitalAffiliation";
import { abort } from "process";
import { GlobalHealthSystem } from "src/app/core/model/v2/healthSystem/global-health-system";
import { Insurance } from "src/app/core/model/v2/insurance";
import { DateAdapter } from "@angular/material/core";
import { Language } from "../../../../core/model/v2/languages";
import { FormArray } from "@angular/forms";
import { PractitionerEducation } from "../../../../core/model/v2/practitioner/practitioner-education";
import { Education } from "../../models/education.model";
import { Awards } from "../../models/awards.model";
import { Certifications } from "../../models/certifications.model";
import { Socialmedia } from "../../models/socialmedia.model";
import { SpecialitySubspecialityCategory } from "../../../../core/model/v2/speciality-subspeciality-category";
import { debug } from "console";
import { PractitionerSpecialty } from "../../../../core/model/v2/practitioner-specialty";
import { SpecialtyCategories } from "../../../../core/model/v2/specialty-categories";
import { SpecializationCategories } from "../../../../core/model/v2/specialization-categories";
import { PractitionerSpecializations } from "../../../../core/model/v2/practitioner-specializations";

@Component({
  selector: "edit-provider-profile",
  templateUrl: "./edit-provider-profile.component.html",
  styleUrls: ["./edit-provider-profile.component.scss"],
})
export class EditProviderProfileComponent implements OnChanges, OnInit {
  @Input() DetailProfessional;
  editProviderForm: FormGroup;
  @Input() practitionerData: Practitioner = new Practitioner(); //@Input()
  codeTableSuffix: CodeTable;
  codeTable: CodeTable;
  languages: LanguageDetails[];
  practitionerSpecialty: PractitionerSpecialty[] = [];
  practitionerSpecializationLst: PractitionerSpecializations[] = [];
  practitionerSpecializationObj: PractitionerSpecializations;
  practitionerSpecialtyObj: PractitionerSpecialty;
  specialty: Specialty[];
  specialties: Specialty[];
  //specialitysubSpecialties: SpecialitySubspecialityCategory[];
  @Output() toggleSidebar = new EventEmitter();
  @Output() togglProviders = new EventEmitter();
  @Output() dataRefresh = new EventEmitter();
  specialityList = [];
  subspecialityList = [];
  languagesList = [];
  language: number;
  langSelect: HTMLElement;
  nLanguage: Language = { languageId: 0, languageName: "" };
  arrLanguages = [];
  practitionerEducation: Education[];
  practitionerAwards: Awards[];
  practitionerCertificates: Certifications[];
  practitionerSMLinks: Socialmedia[];
  isShowContactInfoChkd: boolean = false;
  isNewPatientChkd: boolean = false;
  passingYear: string = '';
  selectedFile = null;
  specialityCategoryId: number = 0;
  subspecialityCategoryId: number = 0;
  subSpecialityCategories: any;
  specializationCategoryid: number = 0;
  specializationCategories: any;
  specializationCategoryList = [];
  specialtyCategories: SpecialtyCategories[];
  specializationCategoriesV2: SpecializationCategories[];
  fbgrp: FormGroup[];
  subCategoryIds: number[] = [];
  selectedCategoryId: number;
  selectedSubCategoryId: number;
  protected ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private dateAdapter: DateAdapter<Date>,
    private fb: FormBuilder,
    private _practiceService: PracticeService,
    private _commonService: CommonService,
    private _userService: UserService,
    private _datePipe: DatePipe,
    private _snackBar: MatSnackBar,
    private cd: ChangeDetectorRef,
    private _loaderService: WindowLoaderService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    //this.dateAdapter.setLocale("en-GB"); //dd/MM/yyyy
    this.dateAdapter.setLocale("en-US"); //MM/dd/yyyy
  }

  ngOnChanges() {
    this.specialityList = [];
    this.subspecialityList = [];
    this.specializationCategoryList = [];
    this.practitionerSpecialty = [];
    this.practitionerData;
    this.codeTableSuffix = { codeName: "", codeItemTables: [] };
    this.codeTable = { codeName: "", codeItemTables: [] };
    this.loadCodes();
    this.formbuilding();

    if (this.practitionerData != undefined && this.practitionerData.specialities != undefined) {
      this.editProviderForm.controls['specialtyFormControl'].setValue(this.practitionerData.specialty);
      this.specialityList.push(this.practitionerData.specialty);
      
      if (this.practitionerData.specialities && this.practitionerData.specialities.length > 0) {
        this.disableControl("specialtyFormControl");
        this.fillSpecializationCategory(this.practitionerData.specialities[0].id);
        this.selectedCategoryId = this.practitionerData.specialities[0].id;
      }
      else
      {
        if (this.specialties && this.specialties.length > 0) {
          this.selectedCategoryId = this.specialties.find(x => x.name == this.practitionerData.specialty).id;
          this.disableControl("specialtyFormControl");
          this.fillSpecializationCategory(this.selectedCategoryId);
        }
        else {
          this.getSpecialities();
        }
      }
     
    }

    //if (this.practitionerData != undefined && this.practitionerData.specialitySubCategories != undefined) {
    //  this.practitionerData.specialitySubCategories.forEach(x => {
    //    this.subspecialityList.push(x.subCategory);
    //    //this.editProviderForm.controls['subSpecialtyFormControl'].setValue(x.id);
    //  });
    //  if (this.practitionerData.specialitySubCategories[0] != undefined) {
    //    this.editProviderForm.controls['subSpecialtyFormControl'].setValue(this.practitionerData.specialitySubCategories[0].subCategory);
    //    this.selectedSubCategoryId = this.practitionerData.specialitySubCategories[0].id;
    //    this.disableControl("subSpecialtyFormControl");
    //    this.fillSpecializationCategory(this.practitionerData.specialitySubCategories[0].id);
    //  }

    //}

    if (this.practitionerData != undefined && this.practitionerData.subSpecialties != undefined) { 
      this.practitionerData.subSpecialties.forEach(x => {
        if (!this.specializationCategoryList.includes(x))
          this.specializationCategoryList.push(x.name);
      })
    }
    this.setSpeciality();
    //this.specialityList.push(this.practitionerData.specialty);
    //this.subspecialityList.push(this.practitionerData.subSpecialty);

    for (var val of this.practitionerData.practitionerLanguages) {
      if (this.languagesList.find(x => x.languageId == val.languageId)) {
        continue;
      }
      else {
        this.languagesList.push(val);
      }
    }

  }
  ngOnInit() {
    //this.loadCodes();

    this.getSpecialities();
    // this.getSpecializations();
    this.loadtreatment();
    this.loadsymptom();
    this.loadHospitalAffilations();
    this.getAllInsurances();
    //this.getSpecialities();
    //this.treatmentautocomplete();
  }
  loadCodes() {

    const genderCode = this.practitionerData
      ? this.practitionerData.gender
      : null;
    const pspecialty = this.practitionerData
      ? this.practitionerData.specialty
      : null;
    const psubspecialty = this.practitionerData
      ? this.practitionerData.subSpecialty
      : null;
    const psuffix = this.practitionerData ? this.practitionerData.suffix : null;

    this._commonService.getItemsForAllCodeNames().subscribe(
      (codes) => {
        this.codeTable = codes.codeTable.filter(function (obj: any) {
          return obj.codeName === "GENDER";
        })[0];
        // this.genderFormControl.setValue(
        //   this.codeTable.codeItemTables.filter(function (obj) {
        //     return obj.itemValue === genderCode;
        //   })[0]
        // );

        this.codeTableSuffix = codes.codeTable.filter(function (obj: any) {
          return obj.codeName === "SUFFIX";
        })[0];
        //console.log(this.codeTableSuffix);

        // this.suffixFormControl.setValue(
        //   this.codeTableSuffix.codeItemTables.filter(function (obj) {
        //     return obj.itemValue === psuffix;
        //   })[0]
        // );
      },
      (error) => {
        console.error(error);
      }
    );

    this._commonService.getLanguages().subscribe(
      (response) => {

        this.languages = response.languages;
        //console.log(this.languages);
      },
      (error) => {
        console.error(error);
      }
    );

    this._commonService.getSpecialty().subscribe(
      (response) => {
        this.specialty = response.specialties;

        // this.specialtyFormControl.setValue(
        //   this.specialty.find((obj) => obj.name == pspecialty)
        // );
        // this.subSpecialtyFormControl.setValue(
        //   this.specialty.find((obj) => obj.name == psubspecialty)
        // );
      },
      (error) => {
        console.error(error);
      }
    );
  }
  compareWithFunc = (a: any, b: any) => a.name == b.languageName;

  addnewTreatment(newTreatmentName) {
    //this._loaderService.show();
    this._practiceService.addnewTreatment(newTreatmentName).subscribe(
      (trt) => {
        this._loaderService.hide();
        if (trt) {
          if (trt.resultStatus.isSuccess) {
            //console.log(trt.result);
            return trt.result;
            //this.onSelectTreatment(trt.result);
          }
          //this.treatmentsOptions = symp;
        }
      },
      (error) => {
        console.error(error);
        this._loaderService.hide();
        return null;
      }
    );
    // var  tr=new Treatment();
    // tr.name=newTreatmentName;
    // console.log(tr);
  }
  deleteSymptom(item: any) {
    this.practitionerData.practitionerSymptoms =
      this.practitionerData.practitionerSymptoms.filter(
        (i) => i.symptom.name !== item.value.name
      );
  }
  deleteTreatment(item: any) {
    this.practitionerData.practitionerTreatments =
      this.practitionerData.practitionerTreatments.filter(
        (i) => i.treatment.name !== item.value.name
      );
  }
  filterSpecialty(val) {

    // NEW CODE THAT REMOVE DUPLICATE DATA FROM SPECIALITY / SUB-SPECIALITY DROPDOWN. (By PRATHMESH RAVAT)
    if (this.specialty) {
      let dataArr = this.specialty.filter((unit) => unit.name.toLowerCase().indexOf(val.toLowerCase()) > -1);
      return dataArr.filter((elem, index, array) => index === array.findIndex((x) => x.name === elem.name));
    }

    return this.specialty;

    // OLD CODE.
    // if (this.specialty)
    //   return this.specialty.filter(
    //     (unit) => unit.name.toLowerCase().indexOf(val.toLowerCase()) > -1
    //   );
    // else return this.specialty;
  }
  OnProviderEditSubmit(editPForm: FormGroup, isAddButton: boolean = false) {
    //if (this.editProviderForm.value.specialtyFormControl > 0 && this.editProviderForm.value.specializationFormControl > 0) {
    //  this.addAllCategoryMapping(editPForm);
    //}
    if (!this.validateCategoryMappingAdd(this.specialityList.length, 0, this.specializationCategoryList.length))
    {
      this.editProviderForm.controls["specialtyFormControl"].setValue("");
      this.editProviderForm.controls["specializationFormControl"].setValue("");
      return false;
    }
    
    //let specialityCatList: string = "";
    let eduEntries = JSON.stringify(this.getEducationDetails().value);
    let awardsEntries = JSON.stringify(this.getAwardsDetails().value);
    let certificateEntries = JSON.stringify(this.getCertificateDetails().value);
    let socialMediaEntries = JSON.stringify(this.getSocialMediaDetails().value);
    var id = this.practitionerData.id;
    //// Treatment
    //const treatmentUpdate = new PractitionerTreatmentsUpdate();
    //treatmentUpdate.practitionerId = this.practitionerData.id;
    //treatmentUpdate.treatmentIds = [];
    //this.practitionerData.practitionerTreatments.forEach((x) => {
    //  treatmentUpdate.treatmentIds.push(x.treatmentId);
    //});
    //this._practiceService.addOrUpdateTreatments(treatmentUpdate).subscribe(
    //  (res) => {
    //  },
    //  (error) => {
    //    console.error(error);
    //  }
    //);
    ///Symptom
    //const symptomUpdate = new PractitionerSymptomsUpdate();
    //symptomUpdate.practitionerId = this.practitionerData.id;
    //symptomUpdate.symptomIds = [];
    //this.practitionerData.practitionerSymptoms.forEach((x) => {
    //  symptomUpdate.symptomIds.push(x.symptomId);
    //});
    //this._loaderService.show();
    //this._practiceService.addOrUpdateSymptoms(symptomUpdate).subscribe(
    //  (res) => {
    //    this._loaderService.hide();
    //  },
    //  (error) => {
    //    console.error(error);
    //    this._loaderService.hide();
    //  }
    //);
    const ids = [];
    this.editProviderForm
      .get("insuranceFormControl")
      .value.filter((ele) => ids.push(ele.id));
    const req = {
      practitionerId: this.practitionerData.id,
      practitionerInsurancePlanIds: ids,
    };
    this._practiceService.updateInsurances(req).subscribe(
      (res) => {
        if (res.isSuccess) {
        }
      },
      (error) => {
        console.error(error);
      }
    );
    //this.loadExistingCategories();
   // this.loadExistingSpecialization();
    const physicianName = {
      practitionerId: this.practitionerData.id,
      firstName: editPForm.value.firstNameFormControl,
      middleName: editPForm.value.middleNameFormControl,
      lastName: editPForm.value.lastNameFormControl,
      suffix: editPForm.value.suffixFormControl,
      professionalDesignation: editPForm.value.titleFormControl,
    };

    const physicianbio = {

      gender: editPForm.value.genderFormControl,
      practitionerId: this.practitionerData.id,
      practitionerLanguages: this.languagesList.map(a => a.languageId),
      dateOfBirth: editPForm.value.dobFormControl,
      //specialty: editPForm.value.specialtyFormControl,
      //subSpecialty: editPForm.value.subSpecialtyFormControl,
      specialty: this.specialityList.toString(),
      subSpecialty: this.subspecialityList.toString(),
      specialization: this.specializationCategoryList.toString(),
      practitionerSpecialties: this.practitionerSpecialty.map(a => a),
      practitionerSpecializations: this.practitionerSpecializationLst.map(a => a),
      boardCertified: editPForm.value.boardCertifiedFormControl,
      education: eduEntries,
      awards: awardsEntries,
      certifications: certificateEntries,
      socialmedia: socialMediaEntries,
      showcontactinfo: this.isShowContactInfoChkd,
      isacceptingnewPatient: this.isNewPatientChkd,
      primaryPhoneNumber: editPForm.value.primaryNoFormControl,
      secondaryPhoneNumber: editPForm.value.secondryNoFormControl,
      primaryEmailAddress: editPForm.value.emailFormControl,
      npi: editPForm.value.NPInumberFormControl,
    };
    const physicianAboutMe = {
      practitionerId: this.practitionerData.id,
      aboutMe: editPForm.value.bioFormControl == undefined ? "" : editPForm.value.bioFormControl,
      personalTouch: editPForm.value.humanTouchFormControl == undefined ? "" : editPForm.value.humanTouchFormControl,
    };
    let hospitalAffiliationRequest = [];

    if (this.practitionerData.hospitalAffiliation) {
      this.practitionerData.hospitalAffiliation.forEach((item) => {
        hospitalAffiliationRequest.push({
          npi: item.npi,
          practitionerId: this.practitionerData.id,
        });
      });
    } else {
      hospitalAffiliationRequest = null;
    }

    //console.log(.practitionerLanguages);
    this._loaderService.show();

    this._practiceService
      .updatePractitionerInfo(
        physicianbio,
        physicianName,
        physicianAboutMe,
        hospitalAffiliationRequest
      )
      .subscribe(
        (userData) => {
          if (!isAddButton) {
            this.togglProviders.emit();
          }
          else {
            this._loaderService.hide();
            this._snackBar.open(
              `Practitioner Specialty Updated Successfully!.`,
              "Ok"
            );
          }
        },
        (error) => {
          this._loaderService.hide();
          if (!isAddButton) {
            this.toggleSidebar.emit();
            this._snackBar.open(
              `Unable to update practitioner specialty!.`,
              "Ok"
            );
          }
          else {
            this._loaderService.hide();
          }
          console.error(error);
        }
      );
    console.log(this.practitionerData);
  }
  OnCancel() {
    this.togglProviders.emit();
  }
  stopLoader() {
    this._loaderService.hide();
  }
  formbuilding() {

    this.isShowContactInfoChkd = this.practitionerData.showContactInfo == null ? false : this.practitionerData.showContactInfo;
    this.isNewPatientChkd = this.practitionerData.isAcceptingNewPatient == null ? false : this.practitionerData.isAcceptingNewPatient;
    let arrEducationDetailsControlsGroup = [];
    let arrAwardDetailsControlsGroup = [];
    let arrCertificateDetailsControlsGroup = [];
    let arrSocialMediaDetailsControlsGroup = [];

    let res: Education[];
    let resAward: Awards[];
    let resCertificate: Certifications[];
    let resSocialMedia: Socialmedia[];

    if (this.practitionerData.education != null) {
      let jsonObj = JSON.parse(this.practitionerData.education); // string to "any" object first
      res = jsonObj as Education[];
    }


    if (this.practitionerData.awards != null) {
      let awardObj = JSON.parse(this.practitionerData.awards); // string to "any" object first
      resAward = awardObj as Awards[];
    }

    if (this.practitionerData.certifications != null) {
      let certificateObj = JSON.parse(this.practitionerData.certifications); // string to "any" object first
      resCertificate = certificateObj as Certifications[];
    }


    if (this.practitionerData.socialMedia != null) {
      let socialMediaObj = JSON.parse(this.practitionerData.socialMedia); // string to "any" object first
      resSocialMedia = socialMediaObj as Socialmedia[];
    }
    // this.editProviderForm.controls['specialtyFormControl'].setValue();

    //this.educationList = [
    //  {
    //    stream: this.practitionerData ? this.practitionerData.education : null,
    //    school: this.practitionerData ? this.practitionerData.education : null,
    //    year: this.practitionerData ? this.practitionerData.education : null
    //  }
    //];


    if (res != undefined && res.length > 0) {
      const formGroups = res.map(x => this.fb.group({
        stream: this.fb.control(x.stream),
        university: this.fb.control(x.university),
        year: this.fb.control(x.year),
      }));
      formGroups.forEach((x) => {
        arrEducationDetailsControlsGroup.push(x);
      })
    }


    if (resAward != undefined && resAward.length > 0) {
      const awardGroups = resAward.map(x => this.fb.group({
        awardname: this.fb.control(x.awardname),
        receivingyear: this.fb.control(x.receivingyear)
      }));
      awardGroups.forEach((x) => {
        arrAwardDetailsControlsGroup.push(x);
      })
    }


    if (resCertificate != undefined && resCertificate.length > 0) {
      const certificateGroups = resCertificate.map(x => this.fb.group({
        certificatename: this.fb.control(x.certificatename),
        receivingyear: this.fb.control(x.receivingyear)

      }));
      certificateGroups.forEach((x) => {
        arrCertificateDetailsControlsGroup.push(x);
      })
    }



    if (resSocialMedia != undefined && resSocialMedia.length > 0) {

      const socialMediaGroups = resSocialMedia.map(x => this.fb.group({
        socialmedianame: this.fb.control(x.socialmedianame),
        profilelink: this.fb.control(x.profilelink)
      }));
      socialMediaGroups.forEach((x) => {
        arrSocialMediaDetailsControlsGroup.push(x);
      })
    }


    this.editProviderForm = this.fb.group({
      NPInumberFormControl: new FormControl(
        this.practitionerData ? this.practitionerData.npi : null,
        [Validators.required]
      ),
      humanTouchFormControl: new FormControl(
        this.practitionerData ? this.practitionerData.humanTouch : null,
        [Validators.required]
      ),
      primaryNoFormControl: new FormControl(
        this.practitionerData ? this.practitionerData.primaryPhoneNumber : null,
        [Validators.required]
      ),
      secondryNoFormControl: new FormControl(
        this.practitionerData ? this.practitionerData.secondaryPhoneNumber : null,
        [Validators.required]
      ),
      emailFormControl: new FormControl(
        this.practitionerData ? this.practitionerData.primaryEmailAddress : null,
        [Validators.required]
      ),
      firstNameFormControl: new FormControl(
        this.practitionerData ? this.practitionerData.firstName : null,
        [Validators.required]
      ),
      middleNameFormControl: new FormControl(
        this.practitionerData ? this.practitionerData.middleName : null,
        []
      ),
      lastNameFormControl: new FormControl(
        this.practitionerData ? this.practitionerData.lastName : null,
        [Validators.required]
      ),
      suffixFormControl: new FormControl(
        this.practitionerData ? this.practitionerData.suffix : null,
        []
      ),
      titleFormControl: new FormControl(
        this.practitionerData ? this.practitionerData.title : null,
        []
      ),
      dobFormControl: new FormControl(
        this.practitionerData ? this.practitionerData.birthDate : null,
        [Validators.required]
      ),
      genderFormControl: new FormControl(
        this.practitionerData ? this.practitionerData.gender : null,
        [Validators.required]
      ),
      languagesFormControl: new FormControl(
        this.practitionerData
          ? this.practitionerData.practitionerLanguages.map(
            ({ languageId }) => languageId
          )
          : [],
        [Validators.required]
      ),
      educationDetail: arrEducationDetailsControlsGroup.length > 0 ? new FormArray(arrEducationDetailsControlsGroup) :
        new FormArray([
          this.fb.group({
            stream: new FormControl(''),
            university: new FormControl(''),
            year: new FormControl('')
          })
        ]),

      awardsDetail: arrAwardDetailsControlsGroup.length > 0 ? new FormArray(arrAwardDetailsControlsGroup) :
        new FormArray([
          this.fb.group({
            awardname: new FormControl(''),
            receivingyear: new FormControl('')
          })
        ]),

      certificateDetail: arrCertificateDetailsControlsGroup.length > 0 ? new FormArray(arrCertificateDetailsControlsGroup) :
        new FormArray([
          this.fb.group({
            certificatename: new FormControl(''),
            receivingyear: new FormControl('')
          })
        ]),

      socialMediaDetail: arrSocialMediaDetailsControlsGroup.length > 0 ? new FormArray(arrSocialMediaDetailsControlsGroup) :
        new FormArray([
          this.fb.group({
            socialmedianame: new FormControl(''),
            profilelink: new FormControl('')
          })
        ]),
      //certificateDetail: new FormArray(arrCertificateDetailsControlsGroup),
      //socialMediaDetail: new FormArray(arrSocialMediaDetailsControlsGroup),


      //educationFormControl: new FormControl(
      //  this.practitionerData ? this.practitionerData.education : null,
      //  []
      //),

      specialtyFormControl: new FormControl(
        []
      ),
      subSpecialtyFormControl: new FormControl(
        []
      ),
      specializationFormControl: new FormControl(
        []
      ),
      boardCertifiedFormControl: new FormControl(
        this.practitionerData ? this.practitionerData.boardCertified : null,
        []
      ),
      bioFormControl: new FormControl(
        this.practitionerData ? this.practitionerData.bio : null,
        []
      ),
      treatmentFormControl: new FormControl(
        this.practitionerData
          ? this.practitionerData.practitionerTreatments.map(
            ({ treatment }) => treatment
          )
          : null,
        []
      ),
      symptomFormControl: new FormControl(
        this.practitionerData
          ? this.practitionerData.practitionerSymptoms.map(
            ({ symptom }) => symptom
          )
          : null,
        []
      ),
      hospitalAffiliationCtrl: new FormControl([], []),
      insuranceFormControl: new FormControl(
        this.practitionerData
          ? this.practitionerData.practitionerInsurance
          : null,
        []
      ),
    });
    // this.editProviderForm.patchValue({
    //   genderFormControl : this.practitionerData.gender
    // })
    //console.log(this.practitionerData.practitionerInsurance);
  }
  ////
  selectedTreatments: Treatment[] = <any>[];
  treatmentLoading = false;

  treatmentInput$ = new Subject<string>();
  searchResultTreatments: Observable<Treatment[]>;
  searchTreatment(term: string = null): Observable<Treatment[]> {
    return this._practiceService.getTreatmentsByName(term);
  }
  trackByFn(item: Treatment) {
    return item.id;
  }
  savehospitalAffiliation() {
    if (this.practitionerData.hospitalAffiliation.length > 0) {
      const affiliationDetails = {
        practitionerId: this.practitionerData.id,
        npi: this.practitionerData.hospitalAffiliation[0].npi,
      };
      this._practiceService
        .updatePhysicianAffiliation(affiliationDetails)
        .subscribe(
          (userData) => {
            // this.practitionerData.hospitalAffiliation=[
            //   self.healthsystemDetails
            // ];
            //self.toggleEvent.emit(self.practitionerData);
          },
          (error) => {
            console.error(error);
          }
        );
    }
  }
  loadtreatment() {
    this.searchResultTreatments = concat(
      of([]), // default items
      this.treatmentInput$.pipe(
        takeUntil(this.ngUnsubscribe),
        filter((data) => data.trim().length > 2),
        debounceTime(500),
        distinctUntilChanged(),
        //tap(() => (this.treatmentLoading = true)),
        switchMap((term) =>
          this._practiceService.getTreatmentsByName(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.treatmentLoading = false))
          )
        )
      )
    );
  }
  onSelectTreatment(treatment: Treatment): void {
    //console.log(treatment);
    if (!treatment.id) {
      this._practiceService.addnewTreatment(treatment.name).subscribe(
        (trt) => {
          this._loaderService.hide();
          if (trt) {
            if (trt.resultStatus.isSuccess) {
              //console.log(trt.result);
              treatment = trt.result;
              if (treatment.id) {
                const practitionerTreatment = new PractitionerTreatment();
                practitionerTreatment.practitioner = this.practitionerData;
                practitionerTreatment.practitionerId = this.practitionerData.id;
                practitionerTreatment.treatment = treatment;
                practitionerTreatment.treatmentId = treatment.id;
                if (
                  this.practitionerData.practitionerTreatments.find(
                    (x) => x.treatment.name == treatment.name
                  ) == null
                ) {
                  this.practitionerData.practitionerTreatments.push(
                    practitionerTreatment
                  );
                } else {
                  // this._snackBar.open(
                  //   `Already existed to ${this.practitionerData.fullName}.`,
                  //   "Ok"
                  // );
                  this._loaderService.hide();
                }
              }
              //this.onSelectTreatment(trt.result);
            }
            //this.treatmentsOptions = symp;
          }
        },
        (error) => {
          console.error(error);
          this._loaderService.hide();
          return null;
        }
      );
    }
    if (treatment.id) {
      //console.log(treatment);
      const practitionerTreatment = new PractitionerTreatment();
      practitionerTreatment.practitioner = this.practitionerData;
      practitionerTreatment.practitionerId = this.practitionerData.id;
      practitionerTreatment.treatment = treatment;
      practitionerTreatment.treatmentId = treatment.id;
      if (
        this.practitionerData.practitionerTreatments.find(
          (x) => x.treatment.name == treatment.name
        ) == null
      ) {
        this.practitionerData.practitionerTreatments.push(
          practitionerTreatment
        );
      } else {
        this._snackBar.open(
          `Already existed to ${this.practitionerData.fullName}.`,
          "Ok"
        );
        this._loaderService.hide();
      }
    }
  }

  //End Treatment

  /// Symptoms
  ////
  selectedSymptoms: Symptom[] = <any>[];
  symptomLoading = false;

  symptomInput$ = new Subject<string>();
  searchResultSymptoms: Observable<Symptom[]>;
  searchSymptom(term: string = null): Observable<Symptom[]> {
    return this._practiceService.getSymptomsByName(term);
  }
  trackSymptomByFn(item: Symptom) {
    return item.id;
  }
  getSpecialities() {
    this._loaderService.show();
    this._commonService.getSpecialty().subscribe((response) => {
      this.specialties = response.specialties;
      this._loaderService.hide();
      if (this.selectedCategoryId == undefined) {
        this.selectedCategoryId = this.specialties.find(x => x.name == this.practitionerData.specialty).id;
        this.disableControl("specialtyFormControl");
        this.fillSpecializationCategory(this.selectedCategoryId);
      }
      
      
    });
  }

  //getSpecialitiesNew() {
  //  this._commonService.getSpecialtySubSpecialityCategories(this.specialityCategoryId, this.subspecialityCategoryId).subscribe((response) => {

  //    if (response.resultStatus.isSuccess == true) {
  //      this.specialitysubSpecialties = response.specialtyCategoriesList;
  //      let spcID = this.specialitysubSpecialties.find(x => x.category === this.practitionerData.specialty);
  //      if (spcID != undefined && this.subSpecialityCategories != undefined) {
  //        let spcSubID = this.subSpecialityCategories.find(x => x.subCategory === this.practitionerData.subSpecialty);
  //        if (spcSubID != undefined) {
  //          this.editProviderForm.controls['subSpecialtyFormControl'].setValue(spcSubID);
  //        }
  //      }
  //    }
  //  });
  //}
  getSpecializations() {
    this._loaderService.show();
    this._commonService.getSpecializationCategories(this.specializationCategoryid).subscribe((response) => {
      if (response.resultStatus.isSuccess == true) {
        this.specializationCategories = response.specializationCategoriesList;
      }
      this._loaderService.hide();
    });

  }
  loadsymptom() {
    this.searchResultSymptoms = concat(
      of([]), // default items
      this.symptomInput$.pipe(
        distinctUntilChanged(),
        filter((data) => data.trim().length > 2),
        debounceTime(500),
        tap(() => (this.symptomLoading = true)),
        switchMap((term) =>
          this._practiceService.getSymptomsByName(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.symptomLoading = false))
          )
        )
      )
    );
  }

  ////

  // onSymptomDelete(symptom): void {
  //   this._loaderService.show();
  //   this._practiceService.deletePractitionerSymptom(symptom.id).subscribe(
  //     (_) => {
  //       this.practitionerData.practitionerSymptoms =
  //         this.practitionerData.practitionerSymptoms.filter(
  //           (i) => i.symptom.name !== symptom.name
  //         );
  //       this._loaderService.hide();
  //     },
  //     (error) => {
  //       console.error(error);
  //       this._loaderService.hide();
  //     },
  //     () => {
  //       this._loaderService.hide();
  //     }
  //   );
  // }

  onSelectSymptom(symptom: Symptom): void {
    //console.log(symptom);
    if (!symptom.id) {
      this._practiceService.addnewSymptom(symptom.name).subscribe(
        (trt) => {
          this._loaderService.hide();
          if (trt) {
            if (trt.resultStatus.isSuccess) {
              //console.log(trt.result);
              symptom = trt.result;
              if (symptom.id) {
                const practitionerSymptom = new PractitionerSymptom();
                practitionerSymptom.practitioner = this.practitionerData;
                practitionerSymptom.practitionerId = this.practitionerData.id;
                practitionerSymptom.symptom = symptom;
                practitionerSymptom.symptomId = symptom.id;
                if (
                  this.practitionerData.practitionerSymptoms.find(
                    (x) => x.symptom.name == symptom.name
                  ) == null
                ) {
                  this.practitionerData.practitionerSymptoms.push(
                    practitionerSymptom
                  );
                } else {
                  // this._snackBar.open(
                  //   `Already existed to ${this.practitionerData.fullName}.`,
                  //   "Ok"
                  // );
                  this._loaderService.hide();
                }
              }
              //this.onSelectSymptom(trt.result);
            }
            //this.symptomsOptions = symp;
          }
        },
        (error) => {
          console.error(error);
          this._loaderService.hide();
          return null;
        }
      );
    }
    if (symptom.id) {
      const practitionerSymptom = new PractitionerSymptom();
      practitionerSymptom.practitioner = this.practitionerData;
      practitionerSymptom.practitionerId = this.practitionerData.id;
      practitionerSymptom.symptom = symptom;
      practitionerSymptom.symptomId = symptom.id;
      if (
        this.practitionerData.practitionerSymptoms.find(
          (x) => x.symptom.name == symptom.name
        ) == null
      ) {
        this.practitionerData.practitionerSymptoms.push(practitionerSymptom);
      } else {
        this._snackBar.open(
          `Already existed to ${this.practitionerData.fullName}.`,
          "Ok"
        );
        this._loaderService.hide();
      }
    }
  }
  ///
  ///Hospital

  // _filterAffilications(value: string): Observable<any[]> {
  //   return this._practiceService.getHealthSystemsByName(value).pipe(
  //     map((a) =>
  //       a.healthSystems.filter((option) => {
  //         return option.name.toLowerCase().indexOf(value.toLowerCase()) === 0;
  //       })
  //     )
  //   );
  // }

  //   optionClicked(event: Event, affiliation: HospitalAffiliation) {
  //     event.stopPropagation();
  //     const self = this;
  //     self.selected = true;
  //     this._practiceService.getHealthSystemByNPI(affiliation.npi).subscribe(
  //       (data) => {
  //         self.healthsystemDetails = data;
  //       },
  //       (error) => {
  //         console.error(error);
  //       }
  //     );
  //   }
  // searchhospital(){
  //   this.filteredAffiliations = this.affilicationCtrl.valueChanges.pipe(
  //     startWith(""),
  //     debounceTime(400),
  //     switchMap((val) => {
  //       return this._filterAffilications(val || "");
  //     })
  //   );
  // }
  searchResultHospitalAffilations: Observable<HospitalAffiliation[]>;
  hospitalInput$ = new Subject<string>();
  //healthsystemDetails:GlobalHealthSystem;
  // _filterAffilications(value: string): Observable<any[]> {
  //   return this._practiceService.getHealthSystemsByName(value).pipe(
  //     map((a) =>
  //       a.healthSystems.filter((option) => {
  //         return option.name.toLowerCase().indexOf(value.toLowerCase()) === 0;
  //       })
  //     )
  //   );
  // }
  deleteAffiliation(npi: string) {
    const affiliationDetails = {
      practitionerId: this.practitionerData.id,
      npi: npi,
    };
    this._practiceService
      .deletePhysicianAffiliation(affiliationDetails)
      .subscribe(
        (userData) => {
          console.log(this.practitionerData.hospitalAffiliation);
          this.practitionerData.hospitalAffiliation =
            this.practitionerData.hospitalAffiliation.filter(function (obj) {
              return obj.npi !== npi;
            });
          console.log(this.practitionerData.hospitalAffiliation);

          this.cd.detectChanges();
        },
        (error) => {
          console.error(error);
        }
      );
  }
  onSelecthsp(selectedHsp) {
    //console.log(this.practitionerData.hospitalAffiliation.find(x=>x.npi==selectedHsp.npi));
    let isExist = this.practitionerData.hospitalAffiliation.find(
      (x) => x.npi == selectedHsp.npi
    );
    if (isExist == undefined) {
      this._loaderService.show();
      //console.log(selectedHsp);
      this._practiceService.getHealthSystemByNPI(selectedHsp.npi).subscribe(
        (data) => {
          this.practitionerData.hospitalAffiliation.push(data);
          this.cd.detectChanges();
          this._loaderService.hide();

          // console.log(this.practitionerData.hospitalAffiliation)
        },
        (error) => {
          console.error(error);
          this._loaderService.hide();
        }
      );
    }
  }
  trackHealthByFn(item: HospitalAffiliation) {
    return item.npi;
  }
  Loadinghs: boolean;
  loadHospitalAffilations() {
    // var def={
    // healthSystems:[]=[]
    //};

    this.searchResultHospitalAffilations = concat(
      of([]), // default items
      this.hospitalInput$.pipe(
        //  takeUntil(this.ngUnsubscribe),
        filter((data) => data.trim().length > 2),
        debounceTime(400),
        distinctUntilChanged(),
        tap(() => (this.Loadinghs = true)),
        switchMap((term) =>
          this._practiceService
            .getHealthSystemsByName(term)

            .pipe(
              map(
                (a) => a.healthSystems
                // .filter((option) => {
                //   return option.name.toLowerCase().indexOf(term.toLowerCase()) === 0;
                // }
                // )
              ),
              catchError(() => of([])), // empty list on error
              tap((ab) => (this.Loadinghs = false))
            )
        )
      )
    );
  }
  ///

  ///Insurance
  allinsurances: Insurance[];
  insurancetrackByFn(item: Insurance) {
    return item.id;
  }
  getAllInsurances() {
    this._commonService.getInsurances().subscribe(
      (list) => {
        this.allinsurances = list.insurances;
        //this.checkForSelectedInsurances();
      },
      (error) => {
        console.error(error);
      }
    );
  }
  ///End Insurance
  onSubmit(isPublished: string, formId: any) {

    if (isPublished == 'speciality') {
      this.specialityList.push(this.specialties.find(x => x.id == this.editProviderForm.value.specialtyFormControl).name);
    }
    else if (isPublished == 'subspeciality') {
      this.specializationCategoryList.push(this.specialties.find(x => x.id == this.editProviderForm.value.specializationFormControl).name);
    }
    else if (isPublished == 'languages') {
      var objLanguage = this.languages.find(x => x.id == this.editProviderForm.value.languagesFormControl);
      this.nLanguage.languageId = objLanguage.id;
      this.nLanguage.languageName = objLanguage.name;
      this.languagesList.push(this.nLanguage);
    }
  }
  removeLanguage(event, item: any): void {
    event.preventDefault();
    event.stopPropagation();

    let index = this.languagesList.findIndex(x => x.languageName === item);
    if (index >= 0) {
      this.languagesList.splice(index, 1);
    }
  }
  //removeSpecialitycategory(event, item: any): void {
  //  event.preventDefault();
  //  event.stopPropagation();

  //  let index = this.specialityList.findIndex(x => x === item);
  //  if (index >= 0) {
  //   // this.specialityList.splice(index, 1);
  //    this.specialityList = [];
  //    let catObj = this.specialties.find(x => x.name === item);
  //    if (catObj != undefined) {

  //        this.subspecialityList = [];
  //        //this.subSpecialityCategories = [];
  //        this.specializationCategories = [];
  //        this.practitionerSpecialty = [];
  //        //this.practitionerSpecializationLst = [];

  //        //this.enableControl("subSpecialtyFormControl");
  //        this.specializationCategoryList = [];
  //        this.editProviderForm.controls['specializationFormControl'].setValue("");
  //        this.editProviderForm.controls['specialtyFormControl'].setValue("");
  //    }
  //  }
  //  if (this.specialityList.length == 0) {
  //    this.enableControl("specialtyFormControl");
  //  }
  //}
  removeSubSpecialitycategory(event, item: any,editPForm:FormGroup): void {
    //this.subCategoryIds = [];
    event.preventDefault();
    event.stopPropagation();

    this.specialityList = [];
    this.specializationCategoryList = [];
    this.specializationCategories = [];
    this.practitionerSpecialtyObj = new PractitionerSpecialty;
    this.practitionerSpecialty = [];
    this.enableControl("specialtyFormControl");
    this.editProviderForm.controls['specialtyFormControl'].setValue("");
    if (this.selectedCategoryId != undefined) {
      this.fillSpecializationCategory(this.selectedCategoryId);
     // this.OnProviderEditSubmit(editPForm, true);
      this.changeDetectorRef.detectChanges();

    }

  }
  //removeSpecializations() {
  //  this._loaderService.show();
  //  this._commonService.GetSpecializationsBySubCategory(this.subCategoryIds).subscribe((response) => {
  //    if (response != undefined) {
  //      if (response.length > 0 && response[0] != null) {
  //        this.specializationCategoryList.forEach(x => {

  //          if (response.find(p => p.category == x) != undefined) {
  //            let itemIndex = this.specializationCategoryList.indexOf(x);
  //            this.specializationCategoryList.splice(itemIndex, 1);
  //          }
  //        });
  //      }
  //    }
  //    this.subCategoryIds = [];
  //    this.changeDetectorRef.detectChanges();
  //    this._loaderService.hide();
  //  });
  //}
  getEducationDetails(): FormArray {
    return this.editProviderForm.get('educationDetail') as FormArray;
  }
  addEducation() {

    let eduDetailArr = this.editProviderForm.get('educationDetail') as FormArray;
    let newEducationEntry = this.fb.group({
      stream: '',
      university: '',
      year: ''
    })
    eduDetailArr.push(newEducationEntry);
  }
  removeEducation(i) {
    let eduDetailArr = this.getEducationDetails();
    eduDetailArr.removeAt(i);

  }

  //*********** Awards ******/
  getAwardsDetails(): FormArray {
    return this.editProviderForm.get('awardsDetail') as FormArray;
  }
  addAward() {

    let awardDetailArr = this.editProviderForm.get('awardsDetail') as FormArray;
    let newAwardEntry = this.fb.group({
      awardname: '',
      receivingyear: ''
    })
    awardDetailArr.push(newAwardEntry);
  }
  removeAward(i) {
    let awardDetailArr = this.getAwardsDetails();
    awardDetailArr.removeAt(i);
  }
  //*********Certifications***********************/
  getCertificateDetails(): FormArray {
    return this.editProviderForm.get('certificateDetail') as FormArray;
  }
  addCertificate() {

    let certificateDetailArr = this.editProviderForm.get('certificateDetail') as FormArray;
    let newCertificateEntry = this.fb.group({
      certificatename: '',
      receivingyear: ''
    })
    certificateDetailArr.push(newCertificateEntry);
  }
  removeCertificate(i) {
    let certificateDetailArr = this.getCertificateDetails();
    certificateDetailArr.removeAt(i);
  }

  //  //*********SocialMediaLinks***********************/
  getSocialMediaDetails(): FormArray {
    return this.editProviderForm.get('socialMediaDetail') as FormArray;
  }
  addSocialMedia() {

    let socialMediaDetailArr = this.editProviderForm.get('socialMediaDetail') as FormArray;
    let newSocialMediaEntry = this.fb.group({
      socialmedianame: '',
      profilelink: ''
    })
    socialMediaDetailArr.push(newSocialMediaEntry);
  }
  removeSocialMedia(i) {
    let socialMediaDetailArr = this.getSocialMediaDetails();
    socialMediaDetailArr.removeAt(i);
  }

  chkFunction(event) {

    console.log(event.target.checked);
    this.isShowContactInfoChkd = event.target.checked;
  }
  chkFunctionNewPatient(event) {

    console.log(event.target.checked);
    this.isNewPatientChkd = event.target.checked;
  }
  YearkeyPress(event: any) {

    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);

    const d = new Date();
    let curYear = d.getFullYear();
    if (event.keyCode != 8 && !pattern.test(inputChar)) {

      event.preventDefault();
    }
    else {
      this.passingYear = this.passingYear + inputChar;
      if (this.passingYear.length == 4 && curYear < parseInt(this.passingYear)) {
        event.preventDefault();
      }
    }
  }
  YearValidate(event: any) {


    let val = event.target.value;
    const d = new Date();

    let curYear = d.getFullYear();
    if (val.length == 4 && curYear <= val) {
      event.target.value = '';
    }
  }
  PassingYearValidate(event: any) {


    let val = event.target.value;
    const d = new Date();

    let curYear = d.getFullYear();
    if (val.length == 4 && curYear < val) {
      event.target.value = '';
    }
  }

  uploadFile(event: any) {
    this.selectedFile = event.target.files[0];
    const payload: FormData = new FormData();
    const self = this;

    if (this.practitionerData.role) {
      payload.append("PractitionerId", this.practitionerData.id.toString());
      payload.append("ImageSource", this.selectedFile);
      this._practiceService.uploadtProfilePicture(payload).subscribe(
        (res) => {
          if (res.isSuccess) {
            this.dataRefresh.emit();
          }
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      payload.append("HealthSystemId", this.practitionerData.id.toString());
      payload.append("ImageSource", this.selectedFile);
      this._practiceService.uploadHealthSystemProfilePicture(payload).subscribe(
        (res) => {
          if (res.isSuccess) {
            this.dataRefresh.emit();
          }
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }

  fillSubCategory(event: any) {
    this.selectedCategoryId = this.editProviderForm.value.specialtyFormControl == undefined ? this.selectedCategoryId : this.editProviderForm.value.specialtyFormControl;
    this.editProviderForm.controls["specializationFormControl"].setValue("");
    this.specializationCategories = [];
    this.subSpecialityCategories = [];
    this.editProviderForm.controls['subSpecialtyFormControl'].setValue("");
    let id = event;
    this._loaderService.show();
    this._commonService.GetSpecialtyCategories(id, 0).subscribe((response) => {

      if (response.resultStatus.isSuccess == true) {

        if (response.specialtyCategoriesList.length > 0 && response.specialtyCategoriesList[0] != null) {
          this.subSpecialityCategories = response.specialtyCategoriesList[0].specialtySubCategoriess;
        }

      }
      this._loaderService.hide();
    });

  }
  //addSpecialitySubSpeciality() {
  //  if (this.validateCategoryMappingAdd(this.editProviderForm.value.specialtyFormControl, this.editProviderForm.value.subSpecialtyFormControl, this.editProviderForm.value.specializationFormControl) == true) {
  //    this.practitionerSpecialtyObj = new PractitionerSpecialty();
  //    this.specialityList = [];
  //    this.practitionerSpecialty = [];
  //    if (!this.specialityList.includes(this.specialitysubSpecialties.find(x => x.id == this.editProviderForm.value.specialtyFormControl).category))
  //      this.specialityList.push(this.specialitysubSpecialties.find(x => x.id == this.editProviderForm.value.specialtyFormControl).category);
  //    if (!this.subspecialityList.includes(this.subSpecialityCategories.find(x => x.id == this.editProviderForm.value.subSpecialtyFormControl).subCategory))
  //      this.subspecialityList.push(this.subSpecialityCategories.find(x => x.id == this.editProviderForm.value.subSpecialtyFormControl).subCategory);
  //    if (this.practitionerData != undefined)
  //      this.practitionerSpecialtyObj.practitionerId = this.practitionerData.id;
  //    if (this.specialitysubSpecialties != undefined)
  //      this.practitionerSpecialtyObj.specialtyCategoryId = this.editProviderForm.value.specialtyFormControl;
  //    if (this.subSpecialityCategories != undefined)
  //      this.practitionerSpecialtyObj.specialtySubCategoryId = this.editProviderForm.value.subSpecialtyFormControl;
  //    this.practitionerSpecialty.push(this.practitionerSpecialtyObj);
  //    this.editProviderForm.controls['specialtyFormControl'].setValue("");
  //    this.editProviderForm.controls['subSpecialtyFormControl'].setValue("");
  //  }

  //}
  convertSpecialityToArray(speciality: string) {
    return speciality.split(',');
  }
  convertSubSpecialityToArray(subspeciality: string) {
    return subspeciality.split(',');
  }
  //addSpecializationCategory() {
  //  if (this.editProviderForm.value.specializationFormControl > 0) {
  //    if (!this.specializationCategoryList.includes(this.specializationCategories.find(x => x.id == this.editProviderForm.value.specializationFormControl).category))
  //      this.specializationCategoryList.push(this.specializationCategories.find(x => x.id == this.editProviderForm.value.specializationFormControl).category);
  //    this.editProviderForm.controls['specializationFormControl'].setValue("");
  //  }
  //}
  removeSpecializationCategory(event, item: string, editPForm: FormGroup): void {

    event.preventDefault();
    event.stopPropagation();
    let index = this.specializationCategoryList.findIndex(x => x === item);
    if (index >= 0) {
      this.specializationCategoryList.splice(index, 1);
      let subId = this.specializationCategories.findIndex(m => m.name == item) != undefined ?
        this.specializationCategories.find(m => m.name == item).id:-1;
      
      if (subId != -1) {
        let sspIndx = this.practitionerSpecialty.findIndex(x => x.specialtySubCategoryId == subId);
        if (sspIndx != -1) {
          this.practitionerSpecialty.splice(sspIndx, 1);
          if (this.specializationCategoryList.length > 0) {
            this.OnProviderEditSubmit(editPForm, true);
          }
          
        }
       
      }
   
    }
  }

  validateCategoryMappingAdd(specialtyCategoryId: number, specialtySubCategoryId: number, specializationCategoryId: any) {
    if (specialtyCategoryId == 0) {
      this._snackBar.open(
        `Please select a Specialty!`,
        "Ok"
      );
      return false;
    }
    //else if (specialtySubCategoryId == 0) {
    //  this._snackBar.open(
    //    `Please select a Sub-Specality!`,
    //    "Ok"
    //  );
    //  return false;
    //}
    
    else if (this.specializationCategories != undefined && (this.specializationCategories.length > 0 && (specializationCategoryId == 0
      || specializationCategoryId == "") && (this.specializationCategoryList.length == 0 || this.specializationCategoryList==undefined))) {
      this._snackBar.open(
        `Please select a Specialization!`,
        "Ok"
      );
      return false;
    }
    else {
      return true;
    }

  }
  fillSpecializationCategory(event: any) {
    this.selectedCategoryId = this.editProviderForm.value.specialtyFormControl == undefined ? this.selectedCategoryId : this.editProviderForm.value.specialtyFormControl;
    this.editProviderForm.controls["specializationFormControl"].setValue("");
    this.specializationCategories = [];
    //this.editProviderForm.controls['specializationFormControl'].setValue("");
    let spCatValue = this.selectedCategoryId;
    spCatValue = spCatValue == undefined ? 0 : spCatValue;
    let id = event;
    this._loaderService.show();
    this._commonService.GetSpecialization(id).subscribe((details) => {
      if (details.response.isSuccess) {
        this.specializationCategories = details.specialties;
      }
      this._loaderService.hide();
    });

  }
  addAllCategoryMapping(editPForm: FormGroup) {

    if (this.validateCategoryMappingAdd(this.editProviderForm.value.specialtyFormControl, this.editProviderForm.value.subSpecialtyFormControl, this.editProviderForm.value.specializationFormControl) == true) {
      this.practitionerSpecialtyObj = undefined;
      let practitionerSpecialtyObjAdd = new PractitionerSpecialty();

      //this.practitionerSpecialty = [];
      if (this.practitionerData != undefined) {
        practitionerSpecialtyObjAdd.practitionerId = this.practitionerData.id;
      }
      if (this.specialityList.length == 0) {
        this.specialityList.push(this.specialties.find(x => x.id == this.editProviderForm.value.specialtyFormControl).name);
        if (this.specialties != undefined) {
          practitionerSpecialtyObjAdd.specialtyCategoryId = this.editProviderForm.value.specialtyFormControl;
        }
      }
      else {
        practitionerSpecialtyObjAdd.specialtyCategoryId = this.selectedCategoryId;
      }

      if ((this.specializationCategories != undefined && this.specializationCategories.length > 0) && (!this.specializationCategoryList.includes(this.specializationCategories.find(x => x.id == this.editProviderForm.value.specializationFormControl).name))) {
        this.specializationCategoryList.push(this.specializationCategories.find(x => x.id == this.editProviderForm.value.specializationFormControl).name);

        if (this.specializationCategories != undefined && this.specializationCategories.length > 0) {
          practitionerSpecialtyObjAdd.specialtySubCategoryId = this.editProviderForm.value.specializationFormControl;
          this.practitionerSpecializationLst.push(this.practitionerSpecializationObj);
        }

        if (practitionerSpecialtyObjAdd.specialtyCategoryId != null
          /* && this.practitionerSpecialtyObj.specialtySubCategoryId != null*/
        ) {
          this.practitionerSpecialty.push(practitionerSpecialtyObjAdd);
          this.disableControl("specialtyFormControl");
          //this.disableControl("subSpecialtyFormControl");
        }
      }

      //this.practitionerSpecializationObj = new PractitionerSpecializations();
      //if (this.practitionerData != undefined) {
      //  if ((this.specializationCategories != undefined && this.specializationCategories.length > 0) && (!this.specializationCategoryList.includes(this.specializationCategories.find(x => x.id == this.editProviderForm.value.specializationFormControl).category))) {
      //    this.specializationCategoryList.push(this.specializationCategories.find(x => x.id == this.editProviderForm.value.specializationFormControl).category);
      //    this.practitionerSpecializationObj.practitionerId = this.practitionerData.id;
      //    if (this.specializationCategories != undefined && this.specializationCategories.length > 0) {
      //      this.practitionerSpecializationObj.specializationCategoryId = this.editProviderForm.value.specializationFormControl;
      //      this.practitionerSpecializationLst.push(this.practitionerSpecializationObj);
      //    }
      //  }
      //  this.editProviderForm.controls['specializationFormControl'].setValue("");
      this.OnProviderEditSubmit(editPForm, true);
    }
  }

  loadExistingCategories() {
    this.specialityList.forEach(x => {

      let psObj = new PractitionerSpecialty();
      psObj.practitionerId = this.practitionerData.id;
      let spObj = this.practitionerData.specialities.find(p => p.name === x);
      if (spObj != undefined) {
        psObj.specialtyCategoryId = spObj.id;
        //this.subspecialityList.forEach(y => {
        //  let subspObj = spObj.specialtySubCategoriess.find(p => p.subCategory === y);
        //  if (subspObj != undefined && (this.practitionerSpecialty.findIndex(x => x.specialtySubCategoryId == subspObj.id) == -1)) {
        //    let psObj1 = new PractitionerSpecialty();
        //    psObj1.practitionerId = this.practitionerData.id;
        //    psObj1.specialtyCategoryId = psObj.specialtyCategoryId;
        //    psObj1.specialtySubCategoryId = subspObj.id;
        //    this.practitionerSpecialty.push(psObj1);
        //  }

        //  this.practitionerSpecialty.forEach(x => {
        //    if (x.specialtyCategoryId == undefined || x.specialtySubCategoryId == undefined) {
        //      let pindx = this.practitionerSpecialty.findIndex(x => x.specialityId == undefined || x.specialtySubCategoryId == undefined)
        //      this.practitionerSpecialty.splice(pindx, 1);
        //    }
        //  })
        //})
      }
      else {
        let sc = this.specialties.find(p => p.name == x);
        if (sc != undefined) {
          psObj.specialtyCategoryId = sc.id;
        }
      }
    })
  }

  loadExistingSpecialization() {
    this.specializationCategoryList.forEach(x => {
      let pspObj = new PractitionerSpecializations();
      let spid = this.specialties.find(a => a.name == x) != undefined ? this.specialties.find(a => a.name == x).id:0;
      let subid = this.specialties.find(a => a.name == x) != undefined ? this.specialties.find(a => a.name == x).id:0;
      this.practitionerSpecialtyObj = new PractitionerSpecialty();
      this.practitionerSpecialtyObj.practitionerId = this.practitionerData.id;
      this.practitionerSpecialtyObj.specializationCategoryId = spid;
      this.practitionerSpecialtyObj.specializationCategoryId = subid;
      if (this.practitionerSpecialty.findIndex(p => p.specialtySubCategoryId == subid) == -1) {
        this.practitionerSpecialty.push(this.practitionerSpecialtyObj);
      }
 
      //let spzObj = this.practitionerData.specialities.find(p => p.name === x);
      //if (spzObj != undefined) {
      //  pspObj.specializationCategoryId = spzObj.id;

      //  if (!this.practitionerSpecializationLst.includes(pspObj)) {
      //    pspObj.practitionerId = this.practitionerData.id;
      //    this.practitionerSpecializationLst.push(pspObj);
      //  }
      //}
    })
  }
  enableControl(ctrlName: string) {
    this.editProviderForm.controls[ctrlName].enable();
  }
  disableControl(ctrlName: string) {
    this.editProviderForm.controls[ctrlName].disable();
  }

  setSpeciality() {
    let spId = 0;
    let subId = 0;
    //if (this.practitionerData != undefined)
    //  this.practitionerSpecialtyObj.practitionerId = this.practitionerData.id;
    if (this.practitionerData.specialities != undefined)
      spId = this.practitionerData.specialities.length > 0 ?
        this.practitionerData.specialities[0].id : 0;
    if (this.practitionerData.subSpecialties != undefined) {
      if (this.practitionerData.subSpecialties.length > 0) {
        this.practitionerData.subSpecialties.forEach(x => {
          this.practitionerSpecialtyObj = new PractitionerSpecialty();
          this.practitionerSpecialtyObj.practitionerId = this.practitionerData.id;
          this.practitionerSpecialtyObj.specialtyCategoryId = this.practitionerData.specialities.length > 0 ?
            this.practitionerData.specialities[0].id : 0;
          this.practitionerSpecialtyObj.specialtySubCategoryId = x.id;
          this.practitionerSpecialty.push(this.practitionerSpecialtyObj);
        })
      }
    }
    //  this.practitionerSpecialtyObj.specialtySubCategoryId = this.practitionerData.subSpecialties.length > 0 ?
    //    this.practitionerData.subSpecialties[0].id : 0;
    //this.practitionerSpecialty.push(this.practitionerSpecialtyObj);
  }
}
